import { c as _c } from "react/compiler-runtime";
import { useCallback, useRef, useState } from 'react';
interface UseNavigationHoverProps {
  switchDelay?: number;
  exitDelay?: number;
}
export const useNavigationHover = t0 => {
  const $ = _c(25);
  const {
    switchDelay: t1,
    exitDelay: t2
  } = t0;
  const switchDelay = t1 === undefined ? 250 : t1;
  const exitDelay = t2 === undefined ? 500 : t2;
  const [activeItem, setActiveItem] = useState("");
  const [isInViewport, setIsInViewport] = useState(false);
  const switchTimeoutRef = useRef(null);
  const exitTimeoutRef = useRef(null);
  const checkExitTimeoutRef = useRef(null);
  const isInContentRef = useRef(false);
  const isInViewportRef = useRef(false);
  const isInTriggerRef = useRef(false);
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      if (switchTimeoutRef.current) {
        clearTimeout(switchTimeoutRef.current);
        switchTimeoutRef.current = null;
      }
      if (exitTimeoutRef.current) {
        clearTimeout(exitTimeoutRef.current);
        exitTimeoutRef.current = null;
      }
      if (checkExitTimeoutRef.current) {
        clearTimeout(checkExitTimeoutRef.current);
        checkExitTimeoutRef.current = null;
      }
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const clearTimeouts = t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      clearTimeouts();
      setActiveItem("");
      setIsInViewport(false);
      isInContentRef.current = false;
      isInViewportRef.current = false;
      isInTriggerRef.current = false;
    };
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const resetNavigation = t4;
  let t5;
  if ($[2] !== exitDelay || $[3] !== switchDelay) {
    t5 = () => {
      if (checkExitTimeoutRef.current) {
        clearTimeout(checkExitTimeoutRef.current);
      }
      checkExitTimeoutRef.current = setTimeout(() => {
        if (!isInTriggerRef.current && !isInContentRef.current) {
          exitTimeoutRef.current = setTimeout(() => {
            setActiveItem("");
            setIsInViewport(false);
          }, exitDelay);
        }
      }, switchDelay);
    };
    $[2] = exitDelay;
    $[3] = switchDelay;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const checkShouldExit = t5;
  let t6;
  if ($[5] !== activeItem || $[6] !== switchDelay) {
    t6 = itemTitle => {
      clearTimeouts();
      isInTriggerRef.current = true;
      if (!activeItem) {
        setActiveItem(itemTitle);
        setIsInViewport(true);
        isInViewportRef.current = true;
        return;
      }
      if (activeItem === itemTitle) {
        setIsInViewport(true);
        isInViewportRef.current = true;
        return;
      }
      switchTimeoutRef.current = setTimeout(() => {
        setActiveItem(itemTitle);
        setIsInViewport(true);
        isInViewportRef.current = true;
      }, switchDelay);
    };
    $[5] = activeItem;
    $[6] = switchDelay;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const handleTriggerEnter = t6;
  let t7;
  if ($[8] !== checkShouldExit) {
    t7 = e => {
      if (e?.pointerType !== "mouse") {
        return;
      }
      isInTriggerRef.current = false;
      if (switchTimeoutRef.current) {
        clearTimeout(switchTimeoutRef.current);
        switchTimeoutRef.current = null;
      }
      checkShouldExit();
    };
    $[8] = checkShouldExit;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const handleTriggerLeave = t7;
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      clearTimeouts();
      isInContentRef.current = true;
      setIsInViewport(true);
      isInViewportRef.current = true;
    };
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const handleContentEnter = t8;
  let t9;
  if ($[11] !== checkShouldExit) {
    t9 = () => {
      isInContentRef.current = false;
      checkShouldExit();
    };
    $[11] = checkShouldExit;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const handleContentLeave = t9;
  let t10;
  if ($[13] !== checkShouldExit) {
    t10 = () => {
      clearTimeouts();
      isInViewportRef.current = true;
      setIsInViewport(true);
      checkShouldExit();
    };
    $[13] = checkShouldExit;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const handleViewportEnter = t10;
  let t11;
  if ($[15] !== exitDelay) {
    t11 = () => {
      isInViewportRef.current = false;
      exitTimeoutRef.current = setTimeout(() => {
        setActiveItem("");
        setIsInViewport(false);
      }, exitDelay);
    };
    $[15] = exitDelay;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const handleViewportLeave = t11;
  let t12;
  if ($[17] !== activeItem || $[18] !== handleContentLeave || $[19] !== handleTriggerEnter || $[20] !== handleTriggerLeave || $[21] !== handleViewportEnter || $[22] !== handleViewportLeave || $[23] !== isInViewport) {
    t12 = {
      resetNavigation,
      activeItem,
      setActiveItem,
      isInViewport,
      handleTriggerEnter,
      handleTriggerLeave,
      handleContentEnter,
      handleContentLeave,
      handleViewportEnter,
      handleViewportLeave
    };
    $[17] = activeItem;
    $[18] = handleContentLeave;
    $[19] = handleTriggerEnter;
    $[20] = handleTriggerLeave;
    $[21] = handleViewportEnter;
    $[22] = handleViewportLeave;
    $[23] = isInViewport;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
};